module.exports = __webpack_public_path__ + "img/mortgages-did-you-know.ecd0c40.png";